export const NOT_HALF_WIDTH_NUMBERS = '半角数字を入力してください';
export const INVALID_DIGITS = '15桁の数字で入力してください';
export const INPUT_EMPTY = 'IMEIを入力してください';
